import { GoToTopButton } from '@shared/components/GoToTopButton';
import { PaginationComponent, Container } from './styles';

type TTPaginationProps = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
};

export function TPagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: TTPaginationProps): JSX.Element {
  return (
    <Container>
      <PaginationComponent
        rowsPerPageOptions={[10, 25, 50]}
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(_event: unknown, newPage: number) =>
          onPageChange(newPage)
        }
        onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onRowsPerPageChange(+event.target.value)
        }
      />

      <GoToTopButton elementId="table-container" />
    </Container>
  );
}
